<template>
	<form class="update-address" ref="user_address">
		<div class="card__header">
			<p class="card__title">You’re all set!</p>
			<div class="card__subtitle">
				<div class="alert alert--notice alert--warning">
					<p class="alert__title">Don’t forget to re-create your orders to keep getting freshly baked bread at your doorstep.</p>
				</div>
			</div>
		</div>
		<div class="card__content">
			<div class="checkbox">
				<input id="confirm" type="checkbox" value="confirm" v-model="checked" class="checkbox__control" />
				<label for="confirm" class="checkbox__label">I understand that I need to re-create my orders with my new address, as changing it might have affected the delivery routes.</label>
			</div>
		</div>
		<div class="card__actions">
			<button :disabled="!checked" type="button" class="button button--md button--secondary" v-on:click="close()">Close</button>
		</div>
	</form>
</template>

<script>
    export default {
			data() {
				return {
					checked: false
				}
			},
			methods: {
				close(){
					this.addressUpdating = false;
					this.$root.accountAddress = 0;
					this.$parent.step = 'UPDATE';
				}
			}
    }
</script>
